const doc = [({"da":({"js":({"admin":({"tenants":({"nav":({"integrations":"Integrationer"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;